import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled, { css } from "styled-components";

export const Toolbar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const ControlsRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

export const DateFilterSlot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ViewTabs = styled.div`
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 16px;
  padding: 8px 16px;
  border-radius: 16px;
  background: ${ColorV2.White};
`;

export const ViewTab = styled.button<{ $isActive: boolean }>`
  ${TypographyV2.b1}
  border: none;
  border-radius: 12px;
  padding: 8px 16px;
  color: ${ColorV2.Blue1};
  background: transparent;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background: ${ColorV2.Blue7};
  }

  ${(props) =>
    props.$isActive &&
    css`
      background: ${ColorV2.Blue6};

      &:hover {
        background: ${ColorV2.Blue6};
      }
    `}
`;

export const ActionsSlot = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
`;
